import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const equipmentConditionsAdapter = getAdapter({ idFieldName: 'value' });

const equipmentConditionsSlice = createSlice({
  name: 'equipmentConditions',
  initialState: equipmentConditionsAdapter.getInitialState(),
  reducers: {
    setEquipmentConditions: (state, { payload: { equipmentConditions } }) => {
      equipmentConditionsAdapter.setAll(state, equipmentConditions);
    }
  }
});

const selectors = equipmentConditionsAdapter.getSelectors(({ equipmentConditions }) => equipmentConditions);

export const getEquipmentConditions = state => selectors.selectAll(state);

export const { setEquipmentConditions } = equipmentConditionsSlice.actions;

export default equipmentConditionsSlice.reducer;
